<div class="enlarge-id">
  <div class="enlarge-id__body">
    @if (isBase64) {
      <img
        src="data:image/jpg;base64,{{ idImage }}"
        alt="id image"
        [style]="idImageStyle"
        data-private
        />
    }
    @if (!isBase64) {
      <img src="{{ idImage }}" alt="id" [style]="idImageStyle" />
    }
  </div>
  <app-button-container>
    <app-button type="primary" (buttonClick)="close()" [dataTestId]="'modal-close'"> Close </app-button>
  </app-button-container>
</div>
